<template>
    <div class="row">
        <div class="col-sm-12 col-xl-6">
            <div class="form-card h-100 p-4">
                <h6 class="mb-4">Add Stock Dividend</h6>
                <form @submit.prevent="onSubmit">
                <div class="form-floating mb-3">
                    <select class="form-select" id="select-platform" aria-label="Select Sector" name="platform" v-model="form.platform_id">
                        <option selected value="0">Select Platform</option>
                        <option v-for="option in platformList" :key="option.platform_id" :value="option.platform_id">
                            {{ option.name }} - {{ option.username }}
                        </option>
                    </select>
                    <label for="select-platform">Select Platform</label>
                </div>
                <div class="form-floating mb-3">
                    <select class="form-select" id="select-stock" aria-label="Select Stock" name="stock_id" v-model="form.stock_id">
                        <option selected value="0">Select Stock</option>
                        <option v-for="option in stock.filter(stock => stock.platform_id == form.platform_id)" :key="option.stock_id" :value="option.stock_id">
                            {{ option.name }}
                        </option>
                    </select>
                    <label for="select-stock">Select Stock</label>
                </div>
                <div class="form-floating mb-3">
                    <input
                    type="number"
                    v-model="form.qty"
                    name="qty"
                    class="form-control"
                    id="qty"
                    placeholder="Quantity"
                    />
                    <label for="qty">Quantity</label>
                </div>
        
                <div class="form-floating mb-3">
                    <input
                    type="number"
                    v-model="form.amount"
                    name="amount"
                    class="form-control"
                    id="amount"
                    placeholder="Amount"
                    />
                    <label for="amount">Amount</label>
                </div>
                <div class="form-floating mb-3">
                    <input
                    type="date"
                    v-model="form.created_at"
                    name="created_at"
                    class="form-control"
                    id="created-at"
                    placeholder="Dividend Date"
                    />
                    <label for="created-at">Dividend Date</label>
                </div>
                <div class="form-floating mb-3">
                    <button :disabled="v$.form.$invalid" type="submit" @click="addDividend()" class="btn btn-primary">
                    Submit
                    </button>
                </div>
                </form>
            </div>
        </div>
        <div class="col-sm-12 col-xl-6" v-if="this.stockWiseDividends">
            <v-card flat rounded="lg" class="dividend-table-card">
            <v-data-table
                :headers="this.grid.headers"
                :items="this.stockWiseDividends"
                :sort-by="[{ key: 'created_at', order: 'desc' }]"
                :items-per-page-options= "[10, 15, 20, 30, 50, 100, 200]"
                :items-per-page="5"
                item-value="name"
                class="custom-data-table"
              >

               <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Total: {{ this.$helper.formatPrice(getTotalDivident()) }}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>
                            <router-link target="_blank" name="stoke-view" :to="{ path: '/stock/view', query: { id: findStockCodeById() }}">
                                {{findStockCodeById()}}
                            </router-link>
                        </v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.qty`]="{ item }">
                    <v-avatar :color="getColor(item)" size="36">
                        {{ item.qty }}
                    </v-avatar>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ this.$helper.formatPrice(item.amount) }}</span>
                </template>

                <template v-slot:[`item.created_at`]="{ item }">
                    <span>{{ this.$helper.formatDate(item.created_at, true) }}</span>
                </template>

            </v-data-table>
            </v-card>
        </div>
    </div>
  </template>
  
<script lang="ts">

import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

import { storeToRefs } from 'pinia';
import { useAlertStore, platformStore } from '@/stores';
import { fetchWrapper } from '@/helpers';

import gql from 'graphql-tag';

const STOCK_WISE_DIVIDENDS_QUERY = gql`
query StockWiseDividends($stockId: [ID]) {
  stockWiseDividends(stock_id: $stockId) {
    stock_id
    qty
    amount
    created_at
    stock {
      name
      platform_id
    }
  }
}`;

const ADD_DIVIDEND_QUERY = gql`
mutation AddDividend($dividendId: ID, $platformId: Int, $stockId: Int, $qty: Int, $amount: Float, $createdAt: String) {
  addDividend(dividend_id: $dividendId, platform_id: $platformId, stock_id: $stockId, qty: $qty, amount: $amount, created_at: $createdAt) {
    dividend_id
    platform_id
    stock_id
    qty
    amount
    created_at
  }
}`;

export default {
    name: "add-stock",
    setup() {
      const alertStore = platformStore();
      const { platformList } = storeToRefs(alertStore);
      return { 
        v$: useVuelidate(),
        alertStore$: useAlertStore(),
        platformList: platformList,
       };
    },
    data() {
      return {
        form: {
          dividend_id: 0,
          platform_id: "",
          stock_id: "",
          qty: "",
          amount: "",
          created_at: "",
        },
        stock: [],
        stockWiseDividends: [],
        grid: {
            headers: [
                { title: 'Qty',    key: 'qty' },
                { title: 'Amount', key: 'amount' },
                { title: 'Date',   key: 'created_at' },
            ]
        },
      };
    },
    validations() {
      return {
        form: {
          platform_id: { required },
          stock_id: { required },
          qty: { required },
          amount: { required },
          created_at: { required },
        },
      };
    },
    methods: {
        addDividend() {
            try {
                this.$apollo.mutate({
                    mutation: ADD_DIVIDEND_QUERY,
                    variables: {
                        "dividendId": parseInt(this.form.dividend_id),
                        "platformId": parseInt(this.form.platform_id),
                        "stockId": this.form.stock_id,
                        "qty": this.form.qty,
                        "amount": this.form.amount,
                        "createdAt": this.form.created_at
                    },
                }).then(() => {
                    this.alertStore$.success('New dividend add successfully.');
                    this.form = {dividend_id: 0, platform_id: "", stock_id: "", qty: "", amount: "", created_at: ""};
                }).catch((error) => {
                    this.alertStore$.error(JSON.stringify(error.message));
                });
            } catch (error) {
                this.alertStore$.error(JSON.stringify(error.message));
            }
        },
        getTotalDivident() {
            return this.stockWiseDividends.reduce((total, dividend) => {
                return total + dividend.amount; // Sum up the amount
            }, 0);
        },
        findStockCodeById() {
            const stock = this.stock.find(stock => stock.stock_id === this.form.stock_id);
            return stock ? stock.code : null; // Return the code or null if not found
        },
        getColor(item) {
            const platform = this.platformList.find(platform => platform.platform_id == item.stock.platform_id);
            return platform ? platform.color : null; // Return the code or null if not found
        }
    },
    watch:{
      'form.platform_id': function (newVal){
        let canFetchNewStockList = this.stock.filter(stock => stock.platform_id == this.form.platform_id);
        if(canFetchNewStockList.length == 0){
          fetchWrapper.post('api/stock', {'platform_id': newVal}).then((response) => {this.stock = response.data;})
        }
       },
       'form.stock_id': function (newVal, oldVal){
            if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
                this.stock.forEach(row => {
                    if(row.stock_id == newVal){
                    this.form.qty = row.qty;
                    return false;
                    }
                });
            }
        },
    },
    apollo: {
        stockWiseDividends: {
            query: STOCK_WISE_DIVIDENDS_QUERY,
            variables() {
                return {
                    stockId: this.form.stock_id
                };
            },
            skip() {
                // Skip the query if stock_id is not set
                return !this.form.stock_id; // Fetch only if stock_id has a value
            },
            error(error) {
                this.alertStore$.error(JSON.stringify(error.message));
            }
        }
    }

};
  </script>

<style scoped>
.form-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}

.dividend-table-card {
  border: 1px solid var(--border);
}

.custom-data-table :deep(thead th) {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border) !important;
}

.custom-data-table :deep(tbody td) {
  font-size: 0.875rem;
  border-bottom: 1px solid #f1f2f4 !important;
}

.custom-data-table :deep(tbody tr:hover) {
  background-color: #f8f9fb;
}
</style>